import { observable, action } from "mobx";

export default class OtherProduct {
  /**
   * @property {number|null}
   */
  @observable otherProductId = null;

  /**
   * @property {string}
   */
  @observable name = "";

  /**
   * @property {string}
   */
  @observable description = "";

  /**
   * @property {number}
   */
  @observable price = 0;

  constructor(data) {
    if (typeof data !== "undefined") {
      this.setData(data);
    }
  }

  @action setData(data) {
    const { otherProductId, name, description, price } = data;

    if (otherProductId !== null) {
      this.otherProductId = otherProductId;
    }

    if (name !== null) {
      this.name = name;
    }

    if (description !== null) {
      this.description = description;
    }

    if (price !== null) {
      this.price = price;
    }
  }
}
